module.exports = __webpack_public_path__ + "static/media/night_flight_5.7bed26f6.jpg";